import React, { createContext, useContext, useState } from "react";

const StatusBarContext = createContext({ info: null, setInfo: () => {} });

export function StatusBarProvider({ children }) {
  const [info, setInfo] = useState(null);
  return (
    <StatusBarContext.Provider value={{ info, setInfo }}>
      {children}
    </StatusBarContext.Provider>
  );
}

// Lets a page publish real, live details (language, compile status, etc.)
// into the global status bar instead of it only ever showing static chrome.
export function useStatusBar() {
  return useContext(StatusBarContext);
}
